import { Box, Divider, Stack, styled } from '@ethings/ui-toolkit';
import { type FC } from 'react';
import { Portal } from '../../types';
import { SideMenuFooter } from './side-menu-footer';
import { SideMenuHeader } from './side-menu-header';
import { SideMenuMenuItems } from './side-menu-items';
import { SideMenuPortalSelect } from './side-menu-portal-select';
import { SideMenuProfile } from './side-menu-profile';
import { SideMenuItemDefinition, SideMenuItemGroupDefinition } from './side-menu.types';

interface SideMenuProps {
  menuItemGroups: SideMenuItemGroupDefinition[];
  footerMenuItems: SideMenuItemDefinition[];
  isOpen: boolean;
  portal: Portal;
}

export const SideMenu: FC<SideMenuProps> = ({ menuItemGroups, footerMenuItems, portal, isOpen }) => {
  return (
    <Root>
      <Inner>
        <SideMenuHeader isOpen={isOpen} />
        <Divider />
        <StyledStack spacing={2}>
          <SideMenuProfile isOpen={isOpen}>
            <SideMenuPortalSelect isOpen={isOpen} portal={portal} />
          </SideMenuProfile>
          <SideMenuMenuItems
            menuItemGroups={menuItemGroups}
            isOpen={isOpen}
          />
        </StyledStack>
      </Inner>
      <SideMenuFooter menuItems={footerMenuItems} isOpen={isOpen} />
    </Root>
  );
};

const Root = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

const Inner = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  height: '100%',
}));

const StyledStack = styled(Stack)(({ theme }) => ({
  padding: `${theme.spacing(2)} calc(${theme.spacing(2)} + 1px) ${theme.spacing(1)} calc(${theme.spacing(2)} + 1px)`,
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
}));
